import { fork, call, put, all, takeLatest } from 'redux-saga/effects';
import asyncInterface from "../../../../asyncInterface";
import * as actionTypes from "./actionType";

function fetchSuggestionData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.suggestACharity.fetchAccountData(fetchPayload);
}

function postCharitySuggestData(fetchPayload) {
    const fetchData = asyncInterface.init();
    return fetchData.suggestACharity.postCharitySuggestData(fetchPayload.payload);
}


function* getDropDownMappingWorker(action){
    try{
        const response = yield call(fetchSuggestionData, action.payload.metaData);            
        yield put({ type: actionTypes.dropDownMappingSuccessType, payload: response.data });
    }
    catch(error){
        yield put({ type: actionTypes.dropdDownMappingFailType, error });
    }
}

function* suggestCharityWorker(action) {
    try{
        const response = yield call(postCharitySuggestData, action);        
        yield put({ type: actionTypes.suggestCharitySuccessType, payload: response.data });
    } catch(error) {
        yield put({ type: actionTypes.suggestCharityFailType, error });
    }
}

function* addToSavedCharityWorker(action) {
    try{
        const response = yield call(postCharitySuggestData, action);        
        yield put({ type: actionTypes.addtoSavedCharitySuccessType, payload: response.data });
    } catch(error) {
        yield put({ type: actionTypes.addToSavedCharityFailType, error });
    }
}

function* getDropDownMappingWatcher() {
    yield takeLatest(actionTypes.receiveDropDownValuesType, getDropDownMappingWorker);
}

function* suggestCharityWatcher() {
    yield takeLatest(actionTypes.suggestCharityType, suggestCharityWorker);
}

function* addToSavedCharityWatcher() {
    yield takeLatest(actionTypes.addToSavedCharityType, addToSavedCharityWorker);
}

export default function* suggestACharityWatcher() {
    yield all([
        fork(getDropDownMappingWatcher),
        fork(suggestCharityWatcher),
        fork(addToSavedCharityWatcher)
    ])
}